import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekCounterpartyType } from './Enums'
/**
* Class CdekLocation
*  Информация об адресе для CDEK
*/
export class CdekLocation extends ActiveModel {

/**
  * officeCode
  * Код ПВЗ<br>
  */
  @ActiveField()
  officeCode?: null | string


  /**
  * cityCode
  * Код населенного пункта СДЭК<br>  */
  @ActiveField(0)
  cityCode: number = 0


/**
  * postalCode
  * Почтовый индекс<br>
  */
  @ActiveField()
  postalCode?: null | string


/**
  * countryCode
  * Код страны в формате ISO_3166-1_alpha-2 (по умолчанию "RU")<br>
  */
  @ActiveField()
  countryCode?: string


/**
  * city
  * Название населенного пункта<br>
  */
  @ActiveField()
  city?: null | string


/**
  * address
  * Строка адреса<br>
  */
  @ActiveField('')
  address: string = ''


  /**
  * counterpartyType
  * Тип контрагента<br>  */
  @ActiveField()
  counterpartyType?: null | CdekCounterpartyType


  /**
  * longitude
  * Долгота<br>  */
  @ActiveField()
  longitude?: null | number


  /**
  * latitude
  * Широта<br>  */
  @ActiveField()
  latitude?: null | number
}
